<template>
  <div class="avatar" :class="titleAlign">
    <v-avatar
      v-if="!loading"
      v-bind="$attrs"
      v-on="$listeners"
      :size="size"
      :style="`font-size: ${getFontSize}px`"
    >
      <slot><v-icon dark>mdi-account</v-icon></slot>
    </v-avatar>
    <v-skeleton-loader v-else type="avatar" :height="size" :width="size" />
    <div v-if="!loading && (subtitle || caption)" class="title-container">
      <p v-if="subtitle" class="subtitle-1">{{ subtitle }}</p>
      <p v-if="caption" class="caption">{{ caption }}</p>
    </div>
  </div>
</template>

<script>
/**
 * @fileoverview Common component for avatars
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */
export default {
  name: "Avatar",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 64,
    },
    subtitle: {
      type: String,
    },
    caption: {
      type: String,
    },
    /**
     * Alignment of avatar and text
     * @values horizontal, vertical
     */
    titleAlign: {
      validator: (value) => {
        return ["horizontal", "vertical"].includes(value);
      },
      default: "vertical",
    },
  },
  computed: {
    getFontSize() {
      return Math.ceil(this.size / 2.5);
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  width: fit-content;
  display: flex;
  &.vertical {
    flex-direction: column;
    align-items: center;
    .title-container {
      align-items: center;
      margin-top: 1em;
    }
  }
  &.horizontal {
    .title-container {
      margin-left: 1em;
    }
  }
}
.v-avatar {
  background: #c4c4c4;
  color: $qvo-color-grey-1000;
  &::v-deep {
    .v-icon {
      font-size: 200%;
    }
  }
}
.v-skeleton-loader {
  &::v-deep {
    .v-skeleton-loader__avatar {
      width: 100%;
      height: 100%;
    }
  }
}
.title-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>